export const mapBackendKeyToStateKey = (key, map) => {
  if (!key || key === 'unknown') {
    return 'unknown';
  }

  const foundPair = map.find((entry) => entry.backendKey === key);
  return foundPair ? foundPair.mappedKey : 'unknown';
};
